/**
 * CSV Export utility — triggers download from the backend export API.
 */
const API_BASE_URL = process.env.REACT_APP_API_URL ?? (
  (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1')
    ? '' : 'http://localhost:8001'
);

/**
 * Download a CSV file from the backend export API.
 * @param {string} endpoint - e.g. 'sales-orders', 'production-orders', 'inventory', 'invoices'
 * @param {Object} params - query parameters (status, date_from, date_to, category, etc.)
 */
export async function downloadCsv(endpoint, params = {}) {
  const token = localStorage.getItem('token');
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value && value !== 'all') query.append(key, value);
  });

  const url = `${API_BASE_URL}/api/exports/${endpoint}${query.toString() ? '?' + query.toString() : ''}`;

  const response = await fetch(url, {
    headers: {
      ...(token && { 'Authorization': `Bearer ${token}` }),
    },
  });

  if (!response.ok) {
    throw new Error(`Export failed: ${response.statusText}`);
  }

  // Extract filename from Content-Disposition header or use default
  const disposition = response.headers.get('Content-Disposition');
  let filename = `${endpoint}_export.csv`;
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match) filename = match[1];
  }

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(downloadUrl);
}
